import React from "react";
import styled from "styled-components";
import { Text4, Text5 } from "./styles";
import { useApp } from "../../contexts";

const Wraper = styled.div`
  position: relative;
  padding: 20px 40px;
  width: 542px;
  background: #fff;
  border-radius: 10px;
  @media screen and (max-width: 1024px) {
    width: 320px;
    height: 160px;
    padding: 20px;
  }
`;

const Title = styled.span`
  color: #333;
  font-family: Inter;
  font-size: 23.063px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

const ButtonSC = styled.div`
  border-radius: 96.096px;
  background: #272729;
  display: flex;
  height: 34.595px;
  width: 150px;
  padding: 18.258px 16px;
  justify-content: center;
  align-items: center;
  gap: 9.61px;
  flex-shrink: 0;
  @media screen and (max-width: 1024px) {
    margin-top: 20px;
  }
  & > span {
    color: #fff;
    text-align: center;
    font-family: Inter;
    font-size: 13.453px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const CardEvent = () => {
  const { T } = useApp();
  return (
    <Wraper>
      <div className="flex gap-8">
        <div className="w-[220px] flex flex-col justify-between">
          <Title>Happy Halloween Earnings</Title>
          <ButtonSC>
            <span>{T("Start promoting")}</span>
          </ButtonSC>
        </div>
        <div className="absolute right-0 lg:static">
          <img
            style={{ width: "160px" }}
            src="/assets/images/event_affiliate_icon.png"
            alt=""
          />
        </div>
      </div>
    </Wraper>
  );
};
